import { FiMapPin } from "react-icons/fi";

import { Input } from "../../input/input";

import {
  AsyncSelect,
  DropdownIndicatorProps,
  chakraComponents
} from "../../select/select";

import { QuestionWithHeaderAndFooter } from "../question";
import { QuestionContent } from "../question-content";
import { SuburbQuestionProps } from "../types";

export const SuburbsQuestion = (props: SuburbQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    isClearable = true,
    cacheOptions = true,
    size,
    contentClassName,
    placeholder,
    disabled,
    changeEventHandler,
    answerProps,
    menuPlacement = "auto",
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    noteProps,
    shouldFetchAsyncData,
    asyncHandler,
    onMenuClose,
    onMenuOpen,
    answerAriaLabel,
    answerDataTestId
  } = props;

  const headerFooterProps = {
    gap,
    required,
    invalid,
    labelClassName,
    questionId,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        {shouldFetchAsyncData ? (
          <AsyncSelect
            id={questionId}
            className={contentClassName}
            size={size}
            isClearable={isClearable}
            cacheOptions={cacheOptions}
            value={answer}
            menuPlacement={menuPlacement}
            disabled={disabled}
            onChange={changeEventHandler}
            loadOptions={asyncHandler}
            placeholder={placeholder}
            aria-label={answerAriaLabel}
            onMenuClose={onMenuClose}
            onMenuOpen={onMenuOpen}
            components={{
              DropdownIndicator: (props: DropdownIndicatorProps) => (
                <chakraComponents.DropdownIndicator {...props}>
                  <FiMapPin />
                </chakraComponents.DropdownIndicator>
              )
            }}
            data-testid={answerDataTestId}
          />
        ) : (
          <Input
            id={questionId}
            className={contentClassName}
            type="text"
            value={answer}
            onChange={changeEventHandler}
            disabled={disabled}
            {...answerProps}
            aria-label={answerAriaLabel}
            size={size}
            data-testid={answerDataTestId}
          />
        )}
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
